interface ControlButtonsProps {
	readonly toggleView: () => void;
	readonly toggleColor: () => void;
	readonly zoomOut: () => void;
	readonly zoomIn: () => void;
}

export const ControlButtons = (props: ControlButtonsProps) => {
	return (
			<div className="grid grid-cols-2 gap-2 p-4 w-32 fixed z-10">
				<button type="button"
				        style={{ right: 265, top: 10, height: 42, width: 80, justifyContent: 'center' }}
				        id="toggle-view-button"
				        className="fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
				        onClick={() => props.toggleView()}></button>
				<button type="button"
				        style={{ right: 140, top: 10, height: 42 }}
				        id="toggle-color-button"
				        className="fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
				        onClick={() => props.toggleColor()}>
					Walnut finish
				</button>
				<button type="button"
				        style={{ right: 80, top: 10 }}
				        className="fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
				        onClick={() => props.zoomOut()}>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
					     stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
						      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM13 10H7"/>
					</svg>
				</button>
				<button type="button"
				        style={{ right: 20, top: 10 }}
				        className="fixed z-10 inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
				        onClick={() => props.zoomIn()}>
					<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24"
					     stroke="currentColor">
						<path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
						      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"/>
					</svg>
				</button>
			</div>
	);
};
